














import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ImpersonateBar extends Vue {
  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get adminCredentials() {
    const businessInfo =
      this.$store.getters['business/getBusinessInfo'] &&
      this.$store.getters['business/getBusinessInfo'].business;
    return {
      fullname:
        (businessInfo &&
          businessInfo.loggedInManager &&
          businessInfo.loggedInManager.fullname) ||
        'Super Admin',
      business: {
        name: (businessInfo && businessInfo.name) || ''
      }
    };
  }

  disableImpersonate() {
    // Synchronous redirect, no API call. The browser aborts in-flight
    // fetches when navigating, so the legacy iframe cannot 401 on stale
    // manager calls during the transition. The dashboard handles
    // POST /auth/impersonate/disable in its own bootstrap.
    window.location.assign('/admin/businesses?disable-impersonate=1');
  }
}
